import { createContext } from 'react';
import { type UseBoostFirebaseEventsReturnType } from '@common/hooks/boost-firebase-events';

const BoostFirebaseEventsContext = createContext(
  {} as UseBoostFirebaseEventsReturnType,
);

export { BoostFirebaseEventsContext };
